import styles from "./Contact.module.scss";

export default function Contact() {
  return (
    <>
      <div className={styles.header}>Czas na kontakt</div>
      <div style={{ marginTop: "10px" }}>Brak nieodwiedzonych kontrahentów</div>
    </>
  );
}
